customElements.get("product-gallery") || customElements.define("product-gallery", class extends HTMLElement {
  constructor() {
    super(), this.imageElements = this.querySelectorAll("[data-product-image]");
  }
  connectedCallback() {
    this.imageElements.length && this.adjustLastImageSpans();
  }
  adjustLastImageSpans() {
    const e = Array.from(this.imageElements), t = e.length;
    t && ([ t - 1, t - 2 ].forEach((t, a) => {
      t >= 0 && !this.isImageColSpan2(e[t], t + 1) && e[t].classList.add("col-span-2");
    }), this.dispatchEvent(new CustomEvent("gallery:layout-adjusted", {
      bubbles: !0,
      detail: {
        totalImages: t,
        lastImage: e[t - 1]
      }
    })));
  }
  isImageColSpan2(e, t) {
    return 1 === t || (t - 4) % 3 == 0 && t >= 4 && t <= 8;
  }
  disconnectedCallback() {}
});